import React from "react";
import AjuanPembayaranMenu from "../components/menu/user/AjuanPembayaranMenu";

const AjuanPembayaran = () => {
  return <AjuanPembayaranMenu />;
};

export default AjuanPembayaran;
